module.exports = __webpack_public_path__ + "img/informal-settlements.d457cb0c.png";